export const articleCategories = `
  data {
  id
    attributes {
      title
    }
  }
`;